export default (event) => {
  const file = event.target.files[0]

  const formData = new FormData()
  formData.append('file', file, file.name)

  return formData
}
